// Resume card for the first-login walkthrough. Hidden unless
// VITE_PLAN_ONBOARDING=true, and hidden once the saved step is done.

import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Button, Card, CardBody, HStack, Text } from '@chakra-ui/react';
import { getPlanOnboarding, planOnboardingEnabled, stepLabel, type PlanOnboarding } from '../../marketingPlans/onboarding';

export function PlanOnboardingResume({ brandId }: { brandId: string | null }) {
  const enabled = planOnboardingEnabled();
  const [state, setState] = useState<PlanOnboarding | null>(null);

  useEffect(() => {
    if (!enabled || !brandId) return;
    let cancelled = false;
    void getPlanOnboarding(brandId).then((next) => {
      if (!cancelled) setState(next);
    });
    return () => { cancelled = true; };
  }, [enabled, brandId]);

  if (!enabled || !state || state.step === 'done') return null;

  return (
    <Card variant="outline" data-testid="plan-onboarding-resume">
      <CardBody>
        <HStack justify="space-between" align="center" wrap="wrap" spacing={3}>
          <Text fontSize="sm" color="brand.ink">
            First-login setup is on <b>{stepLabel(state.step)}</b>.
          </Text>
          <Button as={RouterLink} to="/onboarding/plan" size="sm" variant="outline">
            Continue setup
          </Button>
        </HStack>
      </CardBody>
    </Card>
  );
}
